<template>
    <div class="ts-finder__checkbox ts-finder__checkbox--checkbox">
        <input type="checkbox" @change="applyFilter" :checked="isChecked" :disabled="amountOnApply == 0" :id="checkboxId" :class="{ 'semi-checked' : isSemiChecked }" ref="cbx" />
        <label :for="checkboxId">{{name}} <span class="ts-finder__filterpanel-filter-count">({{amountOnApply}})</span></label>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import * as R from 'ramda';
    import $ from 'jQuery';

    export default {
        props: ['filter', 'name', 'level'],
        computed: {
            ...mapState([
                'selectedCantons',
                'filteredStationsForCantonCount'
            ]),
            isChecked() {
                return this.filter.every((val) => this.selectedCantons.includes(val));
            },
            amountOnApply() {
                return R.filter((station) => this.filter.includes(station.canton), this.filteredStationsForCantonCount).length;
            },
            checkboxId() {
                return "canton_" + this.filter.join();
            },
            isSemiChecked() {
                //ignore everything except level 1 checkboxes
                if (this.level !== 1)
                    return false;

                //intersect selectedCantons and the current checkbox's filter array
                var intersection = this.filter.filter(val => this.selectedCantons.includes(val));
                //set semi-checked on, when we have a partial (but not a full) intersection
                return intersection.length > 0 && intersection.length != this.filter.length;
            }
        },
        methods: {
            ...mapActions([
                'addCantonFilter',
                'removeCantonFilter'
            ]),
            applyFilter(event) {
                //when a level 1 checkbox is semi-checked and clicked, we want it to be unchecked instead of checked (mimicks default behaviour of the capability filters)
                if (event.target.checked && this.isSemiChecked) {
                    $(this.$refs.cbx).prop('checked', false);
                    event.target.checked = false;
                }

                if (event.target.checked) {
                    this.addCantonFilter({ filter: this.filter });
                } else {
                    this.removeCantonFilter({ filter: this.filter });
                }
            }
        }
    };
</script>